interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

export function Pagination({
  currentPage,
  totalPages,
  onPageChange,
}: PaginationProps) {
  const pages = Array.from({ length: totalPages }, (_, i) => i + 1);
  const showEllipsis = totalPages > 7;

  const getVisiblePages = () => {
    if (!showEllipsis) return pages;

    if (currentPage <= 4) {
      return [...pages.slice(0, 5), "...", totalPages];
    }

    if (currentPage >= totalPages - 3) {
      return [1, "...", ...pages.slice(totalPages - 5)];
    }

    return [
      1,
      "...",
      currentPage - 1,
      currentPage,
      currentPage + 1,
      "...",
      totalPages,
    ];
  };

  return (
    <div className="p-4 flex items-center justify-between">
      <button
        onClick={() => onPageChange(Math.max(1, currentPage - 1))}
        disabled={currentPage === 1}
        className="flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground disabled:opacity-50 border border-border rounded-lg px-4 py-2"
      >
        <span>←</span> Previous
      </button>
      <div className="flex items-center gap-2">
        {getVisiblePages().map((page, index) => (
          <button
            key={index}
            onClick={() => typeof page === "number" && onPageChange(page)}
            disabled={page === "..."}
            className={`w-8 h-8 flex items-center justify-center rounded-lg text-sm
                ${
                  page === currentPage
                    ? "bg-brand-50 text-brand-600 font-semibold"
                    : page === "..."
                    ? "cursor-default text-muted-foreground"
                    : "text-muted-foreground hover:bg-accent"
                }`}
          >
            {page}
          </button>
        ))}
      </div>
      <button
        onClick={() => onPageChange(Math.min(totalPages, currentPage + 1))}
        disabled={currentPage === totalPages}
        className="flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground disabled:opacity-50 border border-border rounded-lg px-4 py-2"
      >
        Next <span>→</span>
      </button>
    </div>
  );
}
